module.exports = __webpack_public_path__ + "img/Twitter.7f497779.svg";